import moment from "moment/moment";
import HmacSHA256 from "crypto-js/hmac-sha256";
import Hex from "crypto-js/enc-hex";
import { v4 as uuidv4 } from "uuid";

import {
  securePayCheckSumToken,
  securePayToken,
  securePayUID,
  securePayURL,
} from "../env";
export interface Payer {
  amil?: string;
  kariah_code?: string;
  phone?: string;
  name?: string;
  ic_no?: string;
  address?: string;
  address_2?: string;
  address_3?: string;
  city?: string;
  daerah?: string;
  postcode?: string;
  state?: string;
  zakat_code: string;
  email: string;
  dependant: number;
  rate: number;
  amount: number;
}

export interface PaymentConfig {
  action: string;
  body: string;
  payment_type: string;
  extra_data?: ExtraData;
}

export interface ExtraData {
  amil?: string;
  kariah?: string;
}

export const parseURL = (): PaymentConfig | never => {
  const url = new URL(document.location.toString());

  let paths = url.pathname.split("/").filter((item) => {
    if (item === "") {
      return null;
    }
    return item;
  });

  if (paths.length !== 3) {
    throw new Error("invalid url");
  }

  const [action, body, payment_type] = paths;

  let config: PaymentConfig = { action, body, payment_type };

  console.log(url);
  const extras = url.searchParams.get("extras");

  console.log(extras);
  if (extras) {
    const data = JSON.parse(extras) as ExtraData;

    if (!data.amil && !data.kariah) {
      throw new Error("invalid qr code metadata");
    }

    config.extra_data = data;
  }

  return config;
};

export const generateLink = async (
  body: string,
  payer: Payer,
  extras_func: (payer: Payer) => string
) => {
  const root = "https://prod.snapnpay.co/payments/mobile/checkout/";

  const ts = moment().format("YYYYMMDDHHmmssSSS");
  const payerData = extras_func(payer);

  let refNo = `${ts}~${payerData}`;

  if (payer.amil) {
    refNo = `${payer.amil}${refNo}`;
  }

  let agencyCode = getActualFitrahAgencyCode(body);

  const path = `${root}${refNo}/${payer.amount}/${agencyCode}/${payer.email}`;

  console.log(path);

  //   let uuid = uuidv4();
  //   let extra_data = {
  //     payment_type: "zakat_fitrah",
  //     zakat_address: payer.address,
  //     zakat_address_2: payer.address_2,
  //     zakat_address_3: payer.address_3,
  //     zakat_agency: getActualAgencyCode(body),
  //     zakat_amilcode: payer.amil,
  //     zakat_dependant: payer.dependant,
  //     zakat_email: payer.email,
  //     zakat_ic_no: payer.ic_no,
  //     zakat_name: payer.name,
  //     zakat_phone: payer.phone,
  //     zakat_postcode: payer.postcode,
  //     zakat_rate: payer.rate,
  //     zakat_state: payer.state,
  //     zakat_type: "zakat_fitrah",
  //   };

  //   let payload = {
  //     order_number: uuid,
  //     buyer_name: payer.name,
  //     buyer_email: payer.email,
  //     buyer_phone: payer.phone,
  //     transaction_amount: payer.amount,
  //     product_description: `Payment for order number ${uuid}`,
  //     checksum: "",
  //     token: securePayToken,
  //     params: JSON.stringify(extra_data),
  //   };

  //   try {
  //     let resp = await postSecurePay(payload);

  //     if (resp) {
  //       if (resp.ok === true && resp.status === 200) {
  //         document.location.href = resp.url;
  //       }
  //     }

  //     console.log(resp);
  //   } catch (error) {}

  if (path === "") {
    alert("Sila pastikan maklumat yang diisikan adalah lengkap");
  } else {
    document.location.href = path;
  }
};

export const getActualFitrahAgencyCode = (agency: string) => {
  if (agency === "JHRFITRAH" || agency === "MAIJ") {
    return "JHRFITRAH";
  }

  return agency;
};

export const getActualAgencyCode = (agency: string) => {
  if (agency === "PHGFITRAH") {
    return "PPZP";
  }

  if (agency === "TBSFITRAH") {
    return "ZKBTL";
  }

  if (agency === "MAKFITRAH") {
    return "MAIK";
  }

  if (agency === "MDMFITRAH") {
    return "ZKTRG";
  }

  if (agency === "PRKFITRAH") {
    return "ZKPRK";
  }

  if (agency === "SBHFITRAH") {
    return "ZKSBH";
  }

  if (agency === "NSNFITRAH") {
    return "MAINS";
  }

  if (agency === "JHRFITRAH") {
    return "ZKJHR";
  }

  return agency;
};

const postSecurePay = async (payload: any) => {
  try {
    let string = `${payload.buyer_email}|${payload.buyer_name}|${payload.buyer_phone}||${payload.order_number}|${payload.product_description}||${payload.transaction_amount}|${securePayUID}`;

    let hash = HmacSHA256(string, securePayCheckSumToken);

    var hex = await Hex.stringify(hash);

    payload.checksum = hex;

    let resp = await fetch(securePayURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    return resp;
  } catch (error) {
    console.log(error);
  }
};

type ValidatorFunc = (input: string) => Error | null;

const createLengthValidator = (
  name: string,
  min: number,
  max: number
): ValidatorFunc => {
  return (input: string): Error | null => {
    if (input.length < min) {
      return new Error(`Sila pastikan ruang ${name} diisi`);
    }

    if (input.length > max) {
      return new Error(`Sila pastikan ${name} dalam ${max} huruf sahaja`);
    }

    return null;
  };
};

const createNumberOnlyValidator = (name: string): ValidatorFunc => {
  return (input: string): Error | null => {
    if (/\D+/.test(input)) {
      return new Error(`Sila pastikan ${name} dalam nombor sahaja`);
    }

    return null;
  };
};

export const validateIC = (input: string): Error | null => {
  const err = createLengthValidator("no kp", 7, 12)(input);
  if (err !== null) {
    return err;
  }

  return null;
};

export const validateName = (input: string): Error | null => {
  const err = createLengthValidator("nama", 3, 100)(input);
  if (err !== null) {
    return err;
  }

  return null;
};

export const validateAddress = (name: string) => (
  input: string
): Error | null => {
  const err = createLengthValidator(name, 5, 250)(input);
  if (err !== null) {
    return err;
  }

  return null;
};

export const validatePostcode = (input: string): Error | null => {
  let err = createLengthValidator("poskod", 5, 5)(input);
  if (err !== null) {
    return err;
  }

  err = createNumberOnlyValidator("poskod")(input);
  if (err !== null) {
    return err;
  }

  return null;
};

export const validateState = (input: string): Error | null => {
  const err = createLengthValidator("negeri", 2, 25)(input);
  if (err !== null) {
    return err;
  }

  return null;
};

export const validatePhone = (input: string): Error | null => {
  let err = createLengthValidator("no telefon", 7, 20)(input);
  if (err !== null) {
    return err;
  }

  err = createNumberOnlyValidator("no telefon")(input);
  if (err !== null) {
    return err;
  }

  return null;
};
